export function formValidation(formType, form) {
    class ValidateForm {
        constructor(form) {
            this.Form = form;
            this.formType = formType;
            this.tippy = tippy;
            this.patterns = {
                email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                noSpecialChars: /^[^<>=;]+$/,
                noNumbers: /^([^0-9]*)$/,
                noSpaces: /^\S*$/,
                alphaNumeric: /^[a-zA-Z0-9]+$/,
                numeric: /^\d+$/,
                postalCode: /^[a-zA-Z0-9]{1,20}$/,
                phoneExt: /^\d{1,4}$/
            };
        }

        validate() {
            
            try {
                const errorFields = [];
                const fields = [...this.Form.querySelectorAll('[validate="onsubmit"]')];
                console.log("VALIDATING! " + fields)

                for (let i = 0, l = fields.length; i < l; i++) {
                    const isValid = this.processField(fields[i]);
                    if (!isValid) errorFields.push(fields[i]);
                }

                if (errorFields.length > 0) {
                    this.setFocus(errorFields[0]);
                    return false;
                }

                const dealerField = document.getElementById('DealerCode');
                if (!this.processField(dealerField)) errorFields.push(dealerField);

                return true;
            } catch (exception) {
                console.error(exception);
                return false;
            }
        }
        processField(field) {
            const validateType = field.getAttribute('requiredtype');
            const isValid = this.validateField(field);

            if (isValid) {
                this.setFieldToValid(field);
            } else {
                let errorMessage = '';

                switch (validateType) {
                    case 'name':
                        errorMessage = 'Name must not contain numbers or spaces and should be less than 50 characters.';
                        break;
                    case 'email':
                        errorMessage = 'Please enter a valid email address.';
                        break;
                    case 'company':
                        errorMessage = 'Company name must not contain numbers or spaces and should be less than 50 characters.';
                        break;
                    case 'website':
                        errorMessage = 'Website must not contain numbers or spaces and should be less than 200 characters.';
                        break;
                    case 'postalcode':
                        errorMessage = 'Please enter a valid postal code.';
                        break;
                    case 'phoneext':
                        errorMessage = 'Phone extension must be numeric and up to 4 digits.';
                        break;
                    case 'num8Pattern':
                        errorMessage = 'Please enter an 8-digit alphanumeric value.';
                        break;
                    case 'comments':
                        errorMessage = 'Comments must not contain special characters and should be less than 1000 characters.';
                        break;
                    case 'usage':
                    case 'purchaseplan':
                        errorMessage = 'This field must not contain special characters and should be less than 50 characters.';
                        break;
                    case 'state':
                        errorMessage = 'State must be at least 2 characters long for US and Canada.';
                        break;
                    case 'country':
                        errorMessage = 'You must select your country of residence.';
                        break;
                    case 'tel':
                        errorMessage = 'Please enter a valid phone number (at least 10 digits).';
                        break;
                    case 'dealer':
                        errorMessage = 'Please select a dealer.';
                        break;
                    default:
                        errorMessage = field.getAttribute('invalidmessage') || 'Invalid input';
                        break;
                }

                this.setFieldToInvalid(field, errorMessage);
            }

            return isValid;
        }

        setFieldToValid(field) {
            // Regular fields
            field.classList.remove('invalid');

            // Special handling for DealerCode to remove invalid class from the parent container
            if (field.id === 'DealerCode') {
                const dealerContainer = document.querySelector('.dealer');
                dealerContainer.classList.remove('invalid'); // Remove invalid class from the container
            }
        }

        setFieldToInvalid(field, errorMessage) {
            // Regular fields
            field.classList.add('invalid');
            this.setEventListener(field);

            // Special handling for DealerCode to apply invalid styling to the parent container
            if (field.id === 'DealerCode') {
                const dealerContainer = document.querySelector('.dealer'); // Select parent container
                dealerContainer.classList.add('invalid'); // Add invalid class to the container

                if (errorMessage) {
                    tippy(dealerContainer, {
                        content: errorMessage,
                        trigger: 'mouseenter', // Show error on hover for better visibility
                        placement: 'top-start'
                    });
                }
                return; // Skip further processing for this special case
            }

            // Default error tooltip handling for other fields
            if (errorMessage && errorMessage !== '') {
                const options = {
                    content: errorMessage,
                    trigger: 'focusin',
                    placement: 'top-start'
                };

                if (this.formType === 'Configurator') {
                    options.appendTo = this.Form;
                }

                tippy(field, options);
            }
        }

        setEventListener(field) {
            const validateType = field.getAttribute('requiredtype');
            if (validateType === 'dealer') {
                document.getElementById('DealerCode')?.addEventListener('dealer-change', (event) => {
                    this.fieldListEvent(event, field);
                });
            } else {
                field.addEventListener('blur', (event) => {
                    this.fieldListEvent(event, field);
                });
            }
        }

        fieldListEvent(event, target) {
            const field = target ? target : event.target;
            const isValid = this.processField(field);
        }

        validateField(field) {
            const value = field.value || '';
            const validateType = field.getAttribute('requiredtype');
            const maxLength = parseInt(field.getAttribute('maxlength')) || 50;

            // Required field check
            if (field.hasAttribute('validate') && (!value || !value.trim())) {
                return false;
            }

            // Max length check
            if (value.length > maxLength) {
                return false;
            }

            // Special character check for most fields
            if (validateType !== 'email' && validateType !== 'tel' && validateType !== 'num8Pattern') {
                if (!this.patterns.noSpecialChars.test(value)) {
                    return false;
                }
            }

            switch (validateType) {
                case 'name':
                    return this.patterns.noNumbers.test(value) &&
                        this.patterns.noSpaces.test(value) &&
                        value.length <= 50;

                case 'email':
                    return this.patterns.email.test(value) &&
                        this.patterns.noSpaces.test(value) &&
                        value.length <= 50 &&
                        this.patterns.noSpecialChars.test(value);

                case 'company':
                    return this.patterns.noNumbers.test(value) &&
                        this.patterns.noSpaces.test(value) &&
                        value.length <= 50;

                case 'website':
                    return this.patterns.noNumbers.test(value) &&
                        this.patterns.noSpaces.test(value) &&
                        value.length <= 200;

                case 'postalcode':
                    return this.patterns.postalCode.test(value);

                case 'phoneext':
                    return this.patterns.phoneExt.test(value);

                case 'num8Pattern':
                    return value.length === 8 && this.patterns.alphaNumeric.test(value);

                case 'comments':
                    return value.length <= 1000 && this.patterns.noSpecialChars.test(value);

                case 'usage':
                case 'purchaseplan':
                    return value.length <= 50 && this.patterns.noSpecialChars.test(value);

                case 'state':
                    const countryElement = document.getElementById('BusinessCountry');
                    const country = countryElement ? countryElement.value : '';
                    return this.validateState(country, value) &&
                        this.patterns.noNumbers.test(value) &&
                        this.patterns.noSpaces.test(value) &&
                        value.length <= 50;

                case 'tel':
                    return this.validatePhone(value);

                case 'dealer':
                    const dealerCode = document.getElementById('DealerCode')?.value;
                    return dealerCode && dealerCode.trim().length > 0;

                default:
                    return true;
            }
        }

        validateState(country, state) {
            if (country === 'US' || country === 'CA') {
                return state.length >= 2;
            }
            return true;
        }

        validatePhone(value) {
            let phone = typeof value === 'string' ? value : String(value);
            phone = phone.replace(/\D/g, '');
            return phone.length >= 10;
        }

        validateText(value) {
            if (typeof value === 'string') {
                return value.length > 1;
            }
            return false;
        }

        setFocus(field) {
            const validateType = field.getAttribute('requiredtype');

            switch (validateType) {
                case 'dealer':
                    const locationField = document.getElementById('DealerLocation');
                    if (locationField) locationField.focus();
                    break;

                default:
                    field.focus();
                    break;
            }
        }
    }

    class TruckLeadValidateForm extends ValidateForm {
        constructor(form, formType, tippy) {
            super(form, formType, tippy);
        }
    }

    return formType === 'Configurator'
        ? new TruckLeadValidateForm(form, formType)
        : new ValidateForm(form);
}